/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Swap_Scope_NeverInputs */

const en_us2_swap_scope_never = /** @type {(inputs: Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`And never recommend ${i?.name} again`)
};

const pt_br2_swap_scope_never = /** @type {(inputs: Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`E nunca mais recomendar ${i?.name}`)
};

const es_419_swap_scope_never = /** @type {(inputs: Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Y no volver a recomendar ${i?.name}`)
};

const pt_pt2_swap_scope_never = /** @type {(inputs: Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`E nunca mais recomendar ${i?.name}`)
};

const fr_fr2_swap_scope_never = /** @type {(inputs: Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Et ne plus jamais recommander ${i?.name}`)
};

const de_de2_swap_scope_never = /** @type {(inputs: Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Und ${i?.name} nie wieder empfehlen`)
};

const it_it2_swap_scope_never = /** @type {(inputs: Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`E non consigliare mai più ${i?.name}`)
};

/**
* | output |
* | --- |
* | "And never recommend {name} again" |
*
* @param {Swap_Scope_NeverInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_scope_never = /** @type {((inputs: Swap_Scope_NeverInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Scope_NeverInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_scope_never(inputs)
	if (locale === "es-419") return es_419_swap_scope_never(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_scope_never(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_scope_never(inputs)
	if (locale === "de-DE") return de_de2_swap_scope_never(inputs)
	if (locale === "it-IT") return it_it2_swap_scope_never(inputs)
	return en_us2_swap_scope_never(inputs)
});
export { swap_scope_never as "swap.scope_never" }